import React from 'react';
import './FooterNav.scss';

const FooterNav = (props) => {
  // console.log(props);
  return (
    <div className="footer-bg d-flex justify-content-center">
      <div className="footer-logo">
        <img
          src={`

${props?.fields?.FooterIcon?.value?.src}`}
          className="footer-brand-logo"
          title="TVS iQube Electric Scooter Logo"
          alt="TVS iQUBE Electric Logo"
        />
        <ul className="social-links roboto-medium">
          {props?.fields?.FooterSocialLinks?.map((socialLink, footerIndex) => (
            <li key={footerIndex}>
              <a
                href={socialLink?.fields?.Link?.value?.href}
                target={socialLink?.fields?.Link?.value?.target}
                rel="noopener noreferrer"
              >
                <img
                  src={`

${socialLink?.fields?.SocialIcon?.value?.src}`}
                  alt={socialLink?.fields?.SocialIcon?.value?.alt}
                />
              </a>
            </li>
          ))}
        </ul>
        <ul className="category-links roboto-bold ">
          {props?.fields?.FooterLinks?.map((footerLink, footerIndex) => (
            <li className="roboto-bold " key={footerIndex}>
              <a
                href={footerLink?.fields?.Link?.value?.href}
                target={footerLink?.fields?.Link?.value?.target}
                rel="noopener noreferrer"
              >
                {footerLink?.fields?.Link?.value?.text}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default React.memo(FooterNav);
